<!-- Универсальный текстовый шаг из snapshot шаблона. -->
<template>
  <VehicleInspectionStepLayout :title="step.name" :description="step.description">
    <base-textarea v-model="value" />
    <template #actions>
      <base-primary-button
        size="large"
        :disabled="disabled || (isRequired && !value.trim())"
        @click="complete"
      >
        {{ !isRequired && !value.trim() ? "Пропустить" : "Дальше" }}
      </base-primary-button>
    </template>
  </VehicleInspectionStepLayout>
</template>

<script>
import VehicleInspectionStepLayout from "@/components/Vehicle/Inspection/Step/Layout.vue";

export default {
  name: "VehicleInspectionStepText",
  components: { VehicleInspectionStepLayout },
  props: {
    step: { type: Object, required: true },
    answer: { type: Object, default: null },
    disabled: { type: Boolean, default: false },
  },
  emits: ["complete"],
  data() {
    return { value: this.answer?.value?.value || "" };
  },
  computed: {
    isRequired() { return this.step.config?.required !== false; },
  },
  methods: {
    complete() {
      const text = this.value.trim();
      this.$emit("complete", { value: text ? { value: text } : {} });
    },
  },
};
</script>
